// extracted by mini-css-extract-plugin
module.exports =  {"trash":"trash__3HPm+","copy":"copy__3YBMA","edit":"edit__J5zh5","check":"check__M6g7v","search":"search__3vvJC"};